import { calculateProjectRevenue } from "./projectRevenue";
import { calculateMonthlyPersonnelCost } from "./dailyPersonnelCost";

export function calculateProjectResults(data, projects, period) {
  const revenue = calculateProjectRevenue(data, projects, period);
  const rows = revenue.rows.map(row => ({ ...row, gross: 0, missingSalaryCount: 0 }));
  const matches = (shift, row) => {
    const id = shift.projectId || shift.project;
    const byId = rows.find(project => project.id === id);
    const matched = byId || rows.find(project => project.name === (shift.projectName || shift.project));
    return matched?.id === row.id;
  };
  (data.employees || []).forEach(employee => {
    const employeeData = { ...data, employees: [employee] };
    const employeeHours = calculateProjectRevenue(employeeData, projects, period);
    const totalHours = employeeHours.rows.reduce((sum, row) => sum + row.hours, 0) + employeeHours.unmatchedHours;
    // The empty-shift calculation is the fixed monthly salary, including vacation pay.
    const fixed = employee.payroll?.savedPayType === "monthly"
      ? calculateMonthlyPersonnelCost({ ...employeeData, shifts: [] }, period).gross : 0;
    rows.forEach((row, index) => {
      const cost = calculateMonthlyPersonnelCost({ ...employeeData, shifts: (data.shifts || []).filter(shift => matches(shift, row)) }, period);
      const share = totalHours > 0 ? employeeHours.rows[index].hours / totalHours : 0;
      row.gross += cost.gross - fixed + fixed * share;
      row.missingSalaryCount += cost.missingSalaryCount;
    });
  });
  rows.forEach(row => {
    row.result = row.revenue == null || row.missingSalaryCount > 0 ? null : row.revenue - row.gross;
  });
  const totalCost = calculateMonthlyPersonnelCost(data, period).gross;
  return { rows, unallocatedCost: totalCost - rows.reduce((sum, row) => sum + row.gross, 0) };
}
